module.exports = __webpack_public_path__ + "static/media/YF01_8.c7d5eab5.jpg";